export default {
  ADD_ACTIVITY: 'modal/dashboard/ADD_ACTIVITY',
  ADD_LOG: 'modal/dashboard/ADD_LOG',
  ADD_LOGS: 'modal/dashboard/ADD_LOGS',
  ADD_RESIDENTIAL_PROJECT: 'modal/dashboard/ADD_RESIDENTIAL_PROJECT',
  CONFIRM_ACTIVITY: 'modal/dashboard/CONFIRM_ACTIVITY',
  EDIT_LOG: 'modal/dashboard/EDIT_LOG',
  LOG_DETAIL: 'modal/dashboard/LOG_DETAIL',
  SEND_ASSESSOR_APPROVAL: 'modal/dashboard/SEND_ASSESSOR_APPROVAL',
  SEND_ALREADY_ASSESSED: 'modal/dashboard/SEND_ALREADY_ASSESSED',
  SEND_LEADER_APPROVAL: 'modal/dashboard/SEND_LEADER_APPROVAL',
  SEND_RP_ALREADY_ASSESSED: 'modal/dashboard/SEND_RP_ALREADY_ASSESSED',
  SEND_RP_ASSESSOR_APPROVAL: 'modal/dashboard/SEND_RP_ASSESSOR_APPROVAL',
  SEND_RP_LEADER_APPROVAL: 'modal/dashboard/SEND_RP_LEADER_APPROVAL',

  OVERVIEW_PE: 'modal/dashboard/OVERVIEW_PE',
  COMPLETE_PE: 'modal/dashboard/COMPLETE_PE',
  ASSESSOR_REQUEST_PE: 'modal/dashboard/ASSESSOR_REQUEST_PE',
  ASSESSOR_MISSING_INFO: 'modal/dashboard/ASSESSOR_MISSING_INFO',
  ALREADY_ASSESSED_PE: 'modal/dashboard/ALREADY_ASSESSED_PE',
  LEADER_REQUEST_PE: 'modal/dashboard/LEADER_REQUEST_PE',
  ADD_PE_JOURNEY: 'modal/dashboard/ADD_PE_JOURNEY',

  PREPARATION_AND_TRAINING: 'modal/dashboard/PREPARATION_AND_TRAINING',

  NOTIFICATION_CENTRE: 'modal/dashboard/NOTIFICATION_CENTRE',
  MY_LEADER: 'modal/dashboard/MY_LEADER',
  PROFILE_DETAILS: 'modal/dashboard/PROFILE_DETAILS',
  CONGRATULATION_JOURNEY: 'modal/dashboard/CONGRATULATION_JOURNEY',
  CHANGE_PASSWORD: 'modal/dashboard/CHANGE_PASSWORD',
  CHANGE_OLD_PASSWORD: 'modal/CHANGE_OLD_PASSWORD',
  CHANGE_EMAIL: 'modal/dashboard/CHANGE_EMAIL',
  AWARD_APPROVAL: 'modal/dashboard/AWARD_APPROVAL',
  START_NEW_AWARD: 'modal/dashboard/START_NEW_AWARD',
  SETTINGS: 'modal/dashboard/SETTINGS',
  AFFILIATIONS_OVERVIEW: 'modal/dashboard/AFFILIATIONS_OVERVIEW',
  WWC_STATUS: 'modal/dashboard/WWC_STATUS',
  EDIT_ACTIVITY: 'modal/dashboard/EDIT_ACTIVITY',
  CHANGE_MAJOR_ACTIVITY: 'modal/dashboard/CHANGE_MAJOR_ACTIVITY',
  INFO_SMART_MODAL: 'modal/dashboard/INFO_SMART_MODAL',
  INFO_PERSONAL_SUMMARY_MODAL: 'modal/dashboard/INFO_PERSONAL_SUMMARY_MODAL',
  INFO_ASSESSOR: 'modal/dashboard/INFO_ASSESSOR',
  REVISE_MESSAGE: 'modal/dashboard/REVISE_MESSAGE',
  FILE_UPLOAD: 'modal/dashboard/FILE_UPLOAD',
  FILE_DELETE: 'modal/dashboard/FILE_DELETE',
  USER_GUIDE: 'modal/dashboard/USER_GUIDE',

  ASSESSOR_FILE_UPLOAD: 'modal/assessor/ASSESSOR_FILE_UPLOAD',
  ASSESSOR_FILE_DELETE: 'modal/assessor/ASSESSOR_FILE_DELETE',

  ACCEPT_ACTIVITY: 'modal/dashboard/ACCEPT_ACTIVITY',
  SIGN_OFF: 'modal/dashboard/SIGN_OFF',
  REGISTRATION_INFO: 'modal/dashboard/REGISTRATION_INFO',
  ASSESSOR_GUIDE: 'modal/dashboard/ASSESSOR_GUIDE',

  CHANGE_ROLE: 'modal/CHANGE_ROLE',
  STOP_ASSESSING_SECTION: 'modal/STOP_ASSESSING_SECTION',
  SECURITY_POLICY: 'modal/SECURITY_POLICY',

  NEW_BADGE_ACHIEVED: 'modal/NEW_BADGE_ACHIEVED',

  SET_MFA_CODE: 'modal/SET_MFA_CODE'


}
